module.exports = __webpack_public_path__ + "img/full4-min.79af7ce7.png";